import { render } from "./ShoppingListEditMenu.vue?vue&type=template&id=48baf4d4&scoped=true&ts=true"
import script from "./ShoppingListEditMenu.vue?vue&type=script&lang=ts"
export * from "./ShoppingListEditMenu.vue?vue&type=script&lang=ts"

import "./ShoppingListEditMenu.vue?vue&type=style&index=0&id=48baf4d4&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48baf4d4"]])

export default __exports__